import Vue from "vue";

import Highcharts from "highcharts";
import ExportingModule from "highcharts/modules/exporting";
import GanttModule from "highcharts/modules/gantt";
import PatternFill from "highcharts/modules/pattern-fill";
import Accessibility from "highcharts/modules/accessibility.src";
import HighchartsVue from "highcharts-vue";

Highcharts.setOptions({
	lang: {
		months: [
			"Enero",
			"Febrero",
			"Marzo",
			"Abril",
			"Mayo",
			"Junio",
			"Julio",
			"Agosto",
			"Septiembre",
			"Octubre",
			"Noviembre",
			"Diciembre",
		],
		weekdays: [
			"Domingo",
			"Lunes",
			"Martes",
			"Miércoles",
			"Jueves",
			"Viernes",
			"Sábado",
		],
		shortWeekdays: ["D", "L", "M", "X", "J", "V", "S"],
	},
});

Accessibility(Highcharts);
PatternFill(Highcharts);
GanttModule(Highcharts);
ExportingModule(Highcharts);

Highcharts.addEvent(Highcharts.Axis, "foundExtremes", (e) => {
	if (e.target.options.custom && e.target.options.custom.weekendPlotBands) {
		const axis = e.target,
			chart = axis.chart,
			day = 24 * 36e5,
			isWeekend = (t) => /[06]/.test(chart.time.dateFormat("%w", t)),
			plotBands = [];

		let inWeekend = false;

		for (
			let x = Math.floor(axis.min / day) * day;
			x <= Math.ceil(axis.max / day) * day;
			x += day
		) {
			const last = plotBands.at(-1);
			if (isWeekend(x) && !inWeekend) {
				plotBands.push({
					from: x,
					color: {
						pattern: {
							path: "M 0 10 L 10 0 M -1 1 L 1 -1 M 9 11 L 11 9",
							width: 10,
							height: 10,
							color: "rgba(16,71,130,0.15)",
						},
					},
				});
				inWeekend = true;
			}

			if (!isWeekend(x) && inWeekend && last) {
				last.to = x;
				inWeekend = false;
			}
		}
		axis.options.plotBands = plotBands;
	}
});

Vue.use(HighchartsVue);
